"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _text = require("@mmc/text");
var _homepageCarSelector = _interopRequireDefault(require("../styles/homepage-car-selector.css"));
var _innerCard = _interopRequireDefault(require("./inner-card"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

/**
 * ## HomepageCarSelectorEntry - component
 *
 * This is the card portion of the two-part car selector. It will be fed into the carousel component.
 */
var HomepageCarSelectorEntry = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(HomepageCarSelectorEntry, _React$Component);
  function HomepageCarSelectorEntry(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isFocused: false
    };
    _this.isFocused = _this.isFocused.bind((0, _assertThisInitialized2["default"])(_this));
    _this.isBlurred = _this.isBlurred.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = HomepageCarSelectorEntry.prototype;
  _proto.isFocused = function isFocused() {
    this.setState({
      isFocused: true
    });
  };
  _proto.isBlurred = function isBlurred() {
    this.setState({
      isFocused: false
    });
  };
  _proto.renderLinkCard = function renderLinkCard() {
    var _this$props = this.props,
      carouselslideisactive = _this$props.carouselslideisactive,
      oneTile = _this$props.oneTile,
      theme = _this$props.theme,
      config = _this$props.config,
      addPriceDisclaimer = _this$props.addPriceDisclaimer,
      priceDisclaimerId = _this$props.priceDisclaimerId,
      disclaimerData = _this$props.disclaimerData;
    var active = carouselslideisactive === 'true';
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: handleNestedProp(oneTile, 'oneTile.cta.url'),
      className: _homepageCarSelector["default"].vlpLink,
      "data-year": handleNestedProp(oneTile, 'oneTile.year'),
      "data-code": handleNestedProp(oneTile, 'oneTile.code'),
      "data-name": handleNestedProp(oneTile, 'oneTile.name'),
      tabIndex: active ? undefined : -1,
      onFocus: this.isFocused,
      onBlur: this.isBlurred
    }, /*#__PURE__*/_react["default"].createElement(_innerCard["default"], {
      theme: theme,
      oneTile: oneTile,
      config: config,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    }));
  };
  _proto.renderOptionCard = function renderOptionCard() {
    var _this$props2 = this.props,
      oneTile = _this$props2.oneTile,
      theme = _this$props2.theme,
      config = _this$props2.config,
      handleChangeEvent = _this$props2.handleChangeEvent,
      selectedValue = _this$props2.selectedValue,
      onKeyDown = _this$props2.onKeyDown,
      selectedLabel = _this$props2.selectedLabel,
      isDuplicate = _this$props2.isDuplicate,
      customId = _this$props2.customId,
      addPriceDisclaimer = _this$props2.addPriceDisclaimer,
      priceDisclaimerId = _this$props2.priceDisclaimerId,
      disclaimerData = _this$props2.disclaimerData;
    var codeAndYearString = "" + oneTile.code + (oneTile.year ? "_" + oneTile.year : '');
    var cardvalue = isDuplicate ? codeAndYearString + "-DUPLICATE" : "" + codeAndYearString;
    var sharesValue = selectedValue.includes(codeAndYearString);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      name: oneTile.__typename,
      value: customId || cardvalue,
      "data-year": oneTile.year,
      "data-code": oneTile.code,
      "data-name": oneTile.name,
      checked: "" + selectedValue === cardvalue || selectedValue === customId,
      id: customId || oneTile.__typename + "_" + codeAndYearString + (isDuplicate ? '-DUPLICATE' : ''),
      className: _homepageCarSelector["default"].visuallyHidden + " " + _homepageCarSelector["default"].radioButton + " " + (sharesValue ? _homepageCarSelector["default"].isSelectValue : ''),
      onFocus: this.isFocused,
      onBlur: this.isBlurred,
      onChange: handleChangeEvent,
      onKeyDown: onKeyDown
    }), /*#__PURE__*/_react["default"].createElement("label", {
      className: _homepageCarSelector["default"].vlpLink + " " + _homepageCarSelector["default"].radioCard,
      htmlFor: customId || oneTile.__typename + "_" + codeAndYearString + (isDuplicate ? '-DUPLICATE' : '')
    }, /*#__PURE__*/_react["default"].createElement(_innerCard["default"], {
      theme: theme,
      oneTile: oneTile,
      config: config,
      isLabel: true,
      selectedLabel: selectedLabel,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    })));
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      carouselslideisactive = _this$props3.carouselslideisactive,
      handleChangeEvent = _this$props3.handleChangeEvent,
      classes = _this$props3.classes,
      customId = _this$props3.customId,
      oneTile = _this$props3.oneTile;
    var isFocused = this.state.isFocused;
    var classeToAdd = classes ? classes.join(' ') : '';
    return /*#__PURE__*/_react["default"].createElement("div", {
      carouselslideisactive: carouselslideisactive,
      "data-id": customId || oneTile.code + "_" + oneTile.year,
      className: _homepageCarSelector["default"].primaryCardContainer + " " + classeToAdd + " " + (isFocused && _homepageCarSelector["default"].isFocused)
    }, handleChangeEvent === null ? this.renderLinkCard() : this.renderOptionCard());
  };
  return HomepageCarSelectorEntry;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(HomepageCarSelectorEntry);
exports["default"] = _default;